module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-05.f8739d9e.svg";